export default class TasksApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getTasks(params, httpConfig) {
    return this.httpGet('tasks', params, httpConfig);
  }

  fetchTaskDetails(taskId, params, httpConfig) {
    return this.httpGet(`tasks/${taskId}`, params, httpConfig);
  }

  createTask(task, params, httpConfig) {
    return this.httpPost('tasks', task, params, httpConfig);
  }

  updateTask(task, params, httpConfig) {
    return this.httpPut(`tasks/${task.id}`, task, params, httpConfig);
  }

  deleteTask(taskId, params, httpConfig) {
    return this.httpDelete(`tasks/${taskId}`, params, httpConfig);
  }

  createTaskComment(taskId, params, httpConfig) {
    return this.httpPost(`tasks/${taskId}/comments`, params, httpConfig);
  }

  updateTaskComment(taskId, comment, params, httpConfig) {
    return this.httpPut(`tasks/${taskId}/comments/${comment.id}`, comment, params, httpConfig);
  }

  deleteTaskComment(taskId, commentId, params, httpConfig) {
    return this.httpDelete(`tasks/${taskId}/comments/${commentId}`, params, httpConfig);
  }
}
